export const CommunityNewsRoomTranslations = {
    communityNewsRoomTranslations: {
        pageTitle: 'Community Newsroom',
        description: "Welcome to our newsroom. You'll find company news and events here as well as information about our caregiver bloggers and contributing experts."
    }
}